import React from 'react';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  OrderStatsSortOption,
  SortOrder,
  Order,
} from 'src/graphql/report-service/generated/operations';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import OrderTableRow from './row';

interface HeadCell {
  id: OrderStatsSortOption | string;
  label: string;
  disableSort?: boolean;
  align?: 'right' | 'left';
}

const headCells: HeadCell[] = [
  {
    id: OrderStatsSortOption.OrderNumber,
    label: 'Ordernummer',
  },
  {
    id: OrderStatsSortOption.Date,
    label: 'Orderdatum/tid',
  },
  {
    id: OrderStatsSortOption.Ingestion,
    label: 'In-house/Takeaway',
  },
  {
    id: 'MOBILE_PHONE',
    disableSort: true,
    label: 'Mobiltelefon',
  },
  {
    id: OrderStatsSortOption.PaymentType,
    label: 'Betalmetod',
  },
  {
    id: OrderStatsSortOption.Amount,
    label: 'Belopp (SEK)',
    align: 'right',
  },
  {
    id: OrderStatsSortOption.Tip,
    label: 'Dricks (SEK)',
    align: 'right',
  },
  {
    id: OrderStatsSortOption.Table,
    label: 'Bord',
    align: 'right',
  },
];

const LoadingRows = function () {
  const rows = Array(5).fill('');

  return (
    <>
      {rows.map((row, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableRow key={index}>
          <TableCell>
            <Skeleton variant="text" width={140} />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

const OrderTable = function ({
  sortDirection,
  loading,
  sortBy,
  orders,
  changeSort,
}: {
  sortDirection: SortOrder;
  loading: boolean;
  sortBy: OrderStatsSortOption;
  orders?: Order[];
  changeSort: (sort: OrderStatsSortOption) => void;
}) {
  const tableSortDirection = sortDirection === SortOrder.Ascending ? 'asc' : 'desc';

  return (
    <Card>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {headCells.map((headCell) => (
                <TableCell
                  key={headCell.id}
                  align={headCell.align || 'left'}
                  sortDirection={sortBy === headCell.id ? tableSortDirection : false}
                >
                  {headCell.disableSort ? (
                    headCell.label
                  ) : (
                    <TableSortLabel
                      active={sortBy === headCell.id}
                      direction={tableSortDirection}
                      onClick={() => changeSort(headCell.id as OrderStatsSortOption)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  )}
                </TableCell>
              ))}
              {/* "dud" headcell to leave room for open/close */}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && <LoadingRows />}
            {!loading && orders?.map((order) => <OrderTableRow order={order} key={order.id} />)}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

OrderTable.defaultProps = {
  orders: [],
};

export default OrderTable;
